export const filterPreparation = (obj) => {
  const clonedObj = { ...obj };
  for (const Key in clonedObj) {
    if (clonedObj[Key] === "") {
      clonedObj[Key] = null;
    }
  }
  return clonedObj;
};
